/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ solution: NonNullable<unknown> }} Task_Outcome_Notes_PlaceholderInputs */

const en_task_outcome_notes_placeholder = /** @type {(inputs: Task_Outcome_Notes_PlaceholderInputs) => LocalizedString} */ (i) => {
	if (i?.solution === "accepted_will_pay") return /** @type {LocalizedString} */ (`Describe the agreed payment method and the third party's details…`);
	if (i?.solution === "close_process") return /** @type {LocalizedString} */ (`Explain the reason (this will be shared with the client)`);
	return /** @type {LocalizedString} */ (`Add a note…`)
	
};

const pt_br2_task_outcome_notes_placeholder = /** @type {(inputs: Task_Outcome_Notes_PlaceholderInputs) => LocalizedString} */ (i) => {
	if (i?.solution === "accepted_will_pay") return /** @type {LocalizedString} */ (`Descreva a forma de pagamento combinada e os dados do terceiro…`);
	if (i?.solution === "close_process") return /** @type {LocalizedString} */ (`Explicar motivo (informação será repassada para o cliente)`);
	return /** @type {LocalizedString} */ (`Adicionar uma nota…`)
	
};

/**
* | solution | output |
* | --- | --- |
* | "accepted_will_pay" | "Describe the agreed payment method and the third party's details…" |
* | "close_process" | "Explain the reason (this will be shared with the client)" |
* | * | "Add a note…" |
*
* @param {Task_Outcome_Notes_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_outcome_notes_placeholder = /** @type {((inputs: Task_Outcome_Notes_PlaceholderInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Outcome_Notes_PlaceholderInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_outcome_notes_placeholder(inputs)
	return pt_br2_task_outcome_notes_placeholder(inputs)
});